import { DeepMerger } from '@pacem/pacem-foundation';
import * as Output from './index';
DeepMerger.merge(Output);
